import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IEecsCancellation, IEecsCancellationModal } from '../types/eecs-cancellations.types';

export interface EecsCancellationsInitialState extends BaseDataReducerV2InitialState<IEecsCancellation> {
  selectedCancellation: IEecsCancellation | null;
  currentModal: IEecsCancellationModal | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<IEecsCancellation, EecsCancellationsInitialState>(
  'eecs-cancellations',
);

export const eecsCancellationsInitialState: EecsCancellationsInitialState = {
  ...initialState,
  perPage: 25,
  selectedCancellation: null,
  currentModal: null,
};

export const eecsCancellations = createSlice({
  name: 'eecsCancellations',
  initialState: eecsCancellationsInitialState,
  reducers: {
    setSelectedEecsCancellation(state, action: PayloadAction<IEecsCancellation | null>) {
      state.selectedCancellation = action.payload;
    },
    setEecsCancellationModal(state, action: PayloadAction<IEecsCancellationModal | null>) {
      state.currentModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as EecsCancellationsInitialState, action);
    });
  },
});

export const EecsCancellationsAC = AC;
export const onEecsCancellationsSort = thunks.onSort;
export const onEecsCancellationsFilter = thunks.onFilter;
export const clearEecsCancellationsFilters = AC.clearFilters;
export const setEecsCancellationsCurrentPage = AC.setCurrentPage;

export const { setSelectedEecsCancellation, setEecsCancellationModal } = eecsCancellations.actions;
